import {
  AssistantBackendTools,
  BuilderAgentAssistantTools,
  BuilderAssistantTools,
  DataObservatoryCatalogAgentAssistantTools
} from '@cloud-native/agent-tools'

export default {
  modelAutocomplete: {
    placeholder: 'Select a model',
    cartoManaged: 'CARTO Managed'
  },
  error: 'Something went wrong',
  showDetails: 'Show details',
  errorDialogTitle: 'Error details',
  tools: {
    multipleUsed: '{count} tools used',
    multipleRunning: 'Running {count} tools...',
    [BuilderAgentAssistantTools.UpdateAgentConfiguration]: {
      loading: 'Updating agent configuration...',
      success: 'Updated configuration',
      rationale: {
        useCase: 'Use case',
        instructions: 'Instructions',
        semanticModel: 'Semantic model',
        model: 'Model',
        tools: 'Tools',
        capabilities: 'Capabilities',
        introduction: 'Introduction'
      }
    },
    [BuilderAssistantTools.UpdateMap]: {
      loading: 'Updating the map...',
      success: 'Map updated'
    },
    [BuilderAssistantTools.UpdateMapDataset]: {
      loading: 'Updating a data source...',
      success: 'Data source updated'
    },
    [BuilderAssistantTools.PublishMap]: {
      loading: 'Updating sharing...',
      success: 'Sharing updated'
    },
    [BuilderAssistantTools.CreateNamedVersion]: {
      loading: 'Saving a named version...',
      success: 'Named version saved'
    },
    [BuilderAssistantTools.GetMap]: {
      loading: 'Reading the map...',
      success: 'Map read'
    },
    [BuilderAssistantTools.ListMapDatasets]: {
      loading: 'Reading the data...',
      success: 'Data read'
    },
    [BuilderAssistantTools.Describe]: {
      loading: 'Inspecting the data...',
      success: 'Data inspected'
    },
    [BuilderAssistantTools.ListConnections]: {
      loading: 'Listing connections...',
      success: 'Connections listed'
    },
    [BuilderAssistantTools.ListResources]: {
      loading: 'Browsing connection...',
      success: 'Resources listed'
    },
    [BuilderAssistantTools.SearchResources]: {
      loading: 'Searching for data...',
      success: 'Data found'
    },
    [BuilderAssistantTools.ListMaps]: {
      loading: 'Searching maps...',
      success: 'Maps found'
    },
    [BuilderAssistantTools.GetMapSchema]: {
      loading: 'Checking the schema...',
      success: 'Schema checked'
    },
    [BuilderAssistantTools.GetWorkspaceInfo]: {
      loading: 'Reading workspace details...',
      success: 'Workspace details read'
    },
    [BuilderAssistantTools.ListMapAgentModels]: {
      loading: 'Listing agent models...',
      success: 'Agent models listed'
    },
    [BuilderAssistantTools.GetMapAgentsStatus]: {
      loading: 'Checking AI Agents status...',
      success: 'AI Agents status checked'
    },
    [BuilderAssistantTools.ListWorkflowMcpTools]: {
      loading: 'Listing MCP tools...',
      success: 'MCP tools listed'
    },
    [AssistantBackendTools.ReadGuide]: {
      loading: 'Reading the guide...',
      success: 'Guide read'
    },
    [DataObservatoryCatalogAgentAssistantTools.FilterDatasets]: {
      loading: 'Searching for datasets...',
      success: 'Datasets searched'
    },
    [DataObservatoryCatalogAgentAssistantTools.SearchVariables]: {
      loading: 'Searching for variables...',
      success: 'Variables searched'
    }
  }
}
